var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_6288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50342 23.3516V27.1797C6.50342 27.6325 6.13592 28 5.68311 28H2.40186C1.9485 28 1.58154 27.6325 1.58154 27.1797V23.3516C1.58154 22.8988 1.9485 22.5312 2.40186 22.5312H5.68311C6.13592 22.5312 6.50342 22.8988 6.50342 23.3516Z",
    fill: "#FFE766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0659 19.2959V27.1796C13.0659 27.6325 12.6984 28 12.2456 28H8.96436C8.511 28 8.14404 27.6325 8.14404 27.1796V19.2959C8.14404 18.8431 8.511 18.4756 8.96436 18.4756H12.2456C12.6984 18.4756 13.0659 18.8431 13.0659 19.2959Z",
    fill: "#FFE247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6284 13.2153V27.1798C19.6284 27.6326 19.2609 28.0001 18.8081 28.0001H15.5269C15.0735 28.0001 14.7065 27.6326 14.7065 27.1798V13.2153C14.7065 12.762 15.0735 12.395 15.5269 12.395H18.8081C19.2609 12.395 19.6284 12.762 19.6284 13.2153Z",
    fill: "#FFDE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1909 7.1665V27.1799C26.1909 27.6327 25.8234 28.0002 25.3706 28.0002H22.0894C21.636 28.0002 21.269 27.6327 21.269 27.1799V7.1665C21.269 6.71314 21.636 6.34619 22.0894 6.34619H25.3706C25.8234 6.34619 26.1909 6.71314 26.1909 7.1665Z",
    fill: "#FFDA14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2768 1.28135L24.1949 4.34604C24.0418 4.5708 23.788 4.70533 23.5162 4.70533H20.7758L17.8391 10.3141C17.6975 10.5848 17.418 10.7543 17.1123 10.7543H14.3714L14 11.4313L11.2695 16.4096C11.1251 16.6721 10.8495 16.835 10.5498 16.835H7.75473L5.21012 20.5352C5.05754 20.7578 4.80434 20.8906 4.53418 20.8906H2.40137C1.94855 20.8906 1.58105 20.5231 1.58105 20.0703C1.58105 19.6175 1.94855 19.25 2.40137 19.25H4.10324L6.6473 15.5499C6.80043 15.3273 7.05363 15.1944 7.32324 15.1944H10.0642L13.1666 9.53916C13.311 9.27666 13.5866 9.11369 13.8857 9.11369H16.6163L19.5525 3.5044C19.6941 3.23424 19.9741 3.06471 20.2793 3.06471H23.082L24.92 0.359316C25.1743 -0.015293 25.6846 -0.112637 26.0592 0.14166C26.4343 0.396504 26.5317 0.906738 26.2768 1.28135Z",
    fill: "#736D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2768 1.28135L24.1948 4.34604C24.0417 4.5708 23.788 4.70533 23.5162 4.70533H20.7758L17.8391 10.3141C17.6974 10.5848 17.418 10.7543 17.1123 10.7543H14.3713L14 11.4313V9.11369H16.6162L19.5524 3.50439C19.6941 3.23424 19.9741 3.06471 20.2792 3.06471H23.082L24.92 0.359316C25.1743 -0.015293 25.6845 -0.112637 26.0591 0.14166C26.4343 0.396504 26.5316 0.906738 26.2768 1.28135Z",
    fill: "#59531F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_6288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.c52f15d3d04e79ab46b2583dcfb7be09.svg";
export { ForwardRef as ReactComponent };